/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CategoryDto } from '../models';
// @ts-ignore
import type { CategoryRequestDto } from '../models';
// @ts-ignore
import type { ConflictProblemDto } from '../models';
// @ts-ignore
import type { MergeTagRequestDto } from '../models';
// @ts-ignore
import type { PositionChangeDto } from '../models';
// @ts-ignore
import type { PositionDictionaryDto } from '../models';
// @ts-ignore
import type { PositionDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
// @ts-ignore
import type { TagChangeDto } from '../models';
// @ts-ignore
import type { TagDto } from '../models';
// @ts-ignore
import type { TagRequestDto } from '../models';
/**
 * DictionariesApi - axios parameter creator
 * @export
 */
export const DictionariesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a category
         * @param {CategoryRequestDto} categoryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory: async (categoryRequestDto: CategoryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryRequestDto' is not null or undefined
            assertParamExists('createCategory', 'categoryRequestDto', categoryRequestDto)
            const localVarPath = `/api/v1/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categoryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a tag
         * @param {TagRequestDto} tagRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag: async (tagRequestDto: TagRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagRequestDto' is not null or undefined
            assertParamExists('createTag', 'tagRequestDto', tagRequestDto)
            const localVarPath = `/api/v1/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For one added by mistake. Only while no question is in it and no test draws from it; otherwise 409 with reason IN_USE and the count in detail — deactivate it instead.
         * @summary Delete a category nothing uses
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('deleteCategory', 'categoryId', categoryId)
            const localVarPath = `/api/v1/categories/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For one added by mistake. Only while no question carries it; otherwise 409 with reason IN_USE and the count in detail — merge it into another tag instead.
         * @summary Delete a tag no question carries
         * @param {string} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag: async (tagId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('deleteTag', 'tagId', tagId)
            const localVarPath = `/api/v1/tags/{tagId}`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List categories
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCategories: async (activeOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * jAIn\'s dictionary of positions, copied once a night and changed in jAIn — except whether Ankieter uses a position, which is marked here and survives every copy. A name may stand for more than one position — Kierownik Sklepu has one number in JMD and another in JMS — so the company goes with every entry. Small enough to be listed whole.
         * @summary Positions, as copied from jAIn
         * @param {string} [q] A fragment of the name or of the number, letter case and Polish letters aside. Leave it out for every position.
         * @param {boolean} [activeOnly] true for the positions a question may still be given.
         * @param {boolean} [inAnkieterOnly] true for the positions marked as used in Ankieter — what every list to choose a position from offers. Combine with activeOnly to leave out what jAIn switched off.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositions: async (q?: string, activeOnly?: boolean, inAnkieterOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }

            if (inAnkieterOnly !== undefined) {
                localVarQueryParameter['inAnkieterOnly'] = inAnkieterOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Not a dictionary, just suggestions while typing: the names questions cite their procedures by. The point is that the same procedure is spelled the same way twice, so a review after it changes finds every question — listQuestions takes the name as procedureName.
         * @summary Procedure names already used in the bank
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProcedureNames: async (q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/procedure-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * With \"q\" it serves suggestions while an author types. Suggestions are what actually prevents duplicates; merging only cleans up after them.
         * @summary List tags
         * @param {string} [q] 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTags: async (q?: string, activeOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Moves every question from the source tag to the target and deactivates the source. For the \"bhp\" / \"BHP\" / \"b.h.p.\" that appear after a few months of everyone tagging as they go.
         * @summary Merge one tag into another
         * @param {string} tagId The tag being merged away
         * @param {MergeTagRequestDto} mergeTagRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeTags: async (tagId: string, mergeTagRequestDto: MergeTagRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('mergeTags', 'tagId', tagId)
            // verify required parameter 'mergeTagRequestDto' is not null or undefined
            assertParamExists('mergeTags', 'mergeTagRequestDto', mergeTagRequestDto)
            const localVarPath = `/api/v1/tags/{tagId}/merge`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeTagRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The code prefix can only change while the category has no questions — it is already baked into the keys that were issued. A category in use is not deleted but deactivated: deleting it would strip the classification from its questions and break reports.
         * @summary Rename a category, reorder it or take it out of use
         * @param {string} categoryId 
         * @param {CategoryRequestDto} categoryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory: async (categoryId: string, categoryRequestDto: CategoryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('updateCategory', 'categoryId', categoryId)
            // verify required parameter 'categoryRequestDto' is not null or undefined
            assertParamExists('updateCategory', 'categoryRequestDto', categoryRequestDto)
            const localVarPath = `/api/v1/categories/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categoryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The one thing about a position that is decided here rather than in jAIn. Only what the lists offer changes: a question or test that has the position keeps it either way.
         * @summary Mark whether Ankieter uses a position
         * @param {string} code The number of the function in MDR.
         * @param {PositionChangeDto} positionChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePosition: async (code: string, positionChangeDto: PositionChangeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('updatePosition', 'code', code)
            // verify required parameter 'positionChangeDto' is not null or undefined
            assertParamExists('updatePosition', 'positionChangeDto', positionChangeDto)
            const localVarPath = `/api/v1/positions/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionChangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A tag out of use stays on the questions that carry it and in their history, but the lists that offer tags to add leave it out (activeOnly), and an import refuses it. For a tag that only duplicates another, merge instead: that moves its questions as well.
         * @summary Take a tag out of use, or back into it
         * @param {string} tagId 
         * @param {TagChangeDto} tagChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag: async (tagId: string, tagChangeDto: TagChangeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('updateTag', 'tagId', tagId)
            // verify required parameter 'tagChangeDto' is not null or undefined
            assertParamExists('updateTag', 'tagChangeDto', tagChangeDto)
            const localVarPath = `/api/v1/tags/{tagId}`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagChangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionariesApi - functional programming interface
 * @export
 */
export const DictionariesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictionariesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a category
         * @param {CategoryRequestDto} categoryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategory(categoryRequestDto: CategoryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(categoryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.createCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a tag
         * @param {TagRequestDto} tagRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTag(tagRequestDto: TagRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTag(tagRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.createTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For one added by mistake. Only while no question is in it and no test draws from it; otherwise 409 with reason IN_USE and the count in detail — deactivate it instead.
         * @summary Delete a category nothing uses
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategory(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategory(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.deleteCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For one added by mistake. Only while no question carries it; otherwise 409 with reason IN_USE and the count in detail — merge it into another tag instead.
         * @summary Delete a tag no question carries
         * @param {string} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTag(tagId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTag(tagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.deleteTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List categories
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCategories(activeOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCategories(activeOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.listCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * jAIn\'s dictionary of positions, copied once a night and changed in jAIn — except whether Ankieter uses a position, which is marked here and survives every copy. A name may stand for more than one position — Kierownik Sklepu has one number in JMD and another in JMS — so the company goes with every entry. Small enough to be listed whole.
         * @summary Positions, as copied from jAIn
         * @param {string} [q] A fragment of the name or of the number, letter case and Polish letters aside. Leave it out for every position.
         * @param {boolean} [activeOnly] true for the positions a question may still be given.
         * @param {boolean} [inAnkieterOnly] true for the positions marked as used in Ankieter — what every list to choose a position from offers. Combine with activeOnly to leave out what jAIn switched off.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPositions(q?: string, activeOnly?: boolean, inAnkieterOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionDictionaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPositions(q, activeOnly, inAnkieterOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.listPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Not a dictionary, just suggestions while typing: the names questions cite their procedures by. The point is that the same procedure is spelled the same way twice, so a review after it changes finds every question — listQuestions takes the name as procedureName.
         * @summary Procedure names already used in the bank
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProcedureNames(q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProcedureNames(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.listProcedureNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * With \"q\" it serves suggestions while an author types. Suggestions are what actually prevents duplicates; merging only cleans up after them.
         * @summary List tags
         * @param {string} [q] 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTags(q?: string, activeOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TagDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTags(q, activeOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.listTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Moves every question from the source tag to the target and deactivates the source. For the \"bhp\" / \"BHP\" / \"b.h.p.\" that appear after a few months of everyone tagging as they go.
         * @summary Merge one tag into another
         * @param {string} tagId The tag being merged away
         * @param {MergeTagRequestDto} mergeTagRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeTags(tagId: string, mergeTagRequestDto: MergeTagRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeTags(tagId, mergeTagRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.mergeTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The code prefix can only change while the category has no questions — it is already baked into the keys that were issued. A category in use is not deleted but deactivated: deleting it would strip the classification from its questions and break reports.
         * @summary Rename a category, reorder it or take it out of use
         * @param {string} categoryId 
         * @param {CategoryRequestDto} categoryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategory(categoryId: string, categoryRequestDto: CategoryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategory(categoryId, categoryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.updateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The one thing about a position that is decided here rather than in jAIn. Only what the lists offer changes: a question or test that has the position keeps it either way.
         * @summary Mark whether Ankieter uses a position
         * @param {string} code The number of the function in MDR.
         * @param {PositionChangeDto} positionChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePosition(code: string, positionChangeDto: PositionChangeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePosition(code, positionChangeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.updatePosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A tag out of use stays on the questions that carry it and in their history, but the lists that offer tags to add leave it out (activeOnly), and an import refuses it. For a tag that only duplicates another, merge instead: that moves its questions as well.
         * @summary Take a tag out of use, or back into it
         * @param {string} tagId 
         * @param {TagChangeDto} tagChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTag(tagId: string, tagChangeDto: TagChangeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTag(tagId, tagChangeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.updateTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DictionariesApi - factory interface
 * @export
 */
export const DictionariesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictionariesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a category
         * @param {CategoryRequestDto} categoryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory(categoryRequestDto: CategoryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDto> {
            return localVarFp.createCategory(categoryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a tag
         * @param {TagRequestDto} tagRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(tagRequestDto: TagRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TagDto> {
            return localVarFp.createTag(tagRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * For one added by mistake. Only while no question is in it and no test draws from it; otherwise 409 with reason IN_USE and the count in detail — deactivate it instead.
         * @summary Delete a category nothing uses
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCategory(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * For one added by mistake. Only while no question carries it; otherwise 409 with reason IN_USE and the count in detail — merge it into another tag instead.
         * @summary Delete a tag no question carries
         * @param {string} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(tagId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTag(tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List categories
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCategories(activeOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryDto>> {
            return localVarFp.listCategories(activeOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * jAIn\'s dictionary of positions, copied once a night and changed in jAIn — except whether Ankieter uses a position, which is marked here and survives every copy. A name may stand for more than one position — Kierownik Sklepu has one number in JMD and another in JMS — so the company goes with every entry. Small enough to be listed whole.
         * @summary Positions, as copied from jAIn
         * @param {string} [q] A fragment of the name or of the number, letter case and Polish letters aside. Leave it out for every position.
         * @param {boolean} [activeOnly] true for the positions a question may still be given.
         * @param {boolean} [inAnkieterOnly] true for the positions marked as used in Ankieter — what every list to choose a position from offers. Combine with activeOnly to leave out what jAIn switched off.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositions(q?: string, activeOnly?: boolean, inAnkieterOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PositionDictionaryDto> {
            return localVarFp.listPositions(q, activeOnly, inAnkieterOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Not a dictionary, just suggestions while typing: the names questions cite their procedures by. The point is that the same procedure is spelled the same way twice, so a review after it changes finds every question — listQuestions takes the name as procedureName.
         * @summary Procedure names already used in the bank
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProcedureNames(q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.listProcedureNames(q, options).then((request) => request(axios, basePath));
        },
        /**
         * With \"q\" it serves suggestions while an author types. Suggestions are what actually prevents duplicates; merging only cleans up after them.
         * @summary List tags
         * @param {string} [q] 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTags(q?: string, activeOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<TagDto>> {
            return localVarFp.listTags(q, activeOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Moves every question from the source tag to the target and deactivates the source. For the \"bhp\" / \"BHP\" / \"b.h.p.\" that appear after a few months of everyone tagging as they go.
         * @summary Merge one tag into another
         * @param {string} tagId The tag being merged away
         * @param {MergeTagRequestDto} mergeTagRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeTags(tagId: string, mergeTagRequestDto: MergeTagRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TagDto> {
            return localVarFp.mergeTags(tagId, mergeTagRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The code prefix can only change while the category has no questions — it is already baked into the keys that were issued. A category in use is not deleted but deactivated: deleting it would strip the classification from its questions and break reports.
         * @summary Rename a category, reorder it or take it out of use
         * @param {string} categoryId 
         * @param {CategoryRequestDto} categoryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory(categoryId: string, categoryRequestDto: CategoryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDto> {
            return localVarFp.updateCategory(categoryId, categoryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The one thing about a position that is decided here rather than in jAIn. Only what the lists offer changes: a question or test that has the position keeps it either way.
         * @summary Mark whether Ankieter uses a position
         * @param {string} code The number of the function in MDR.
         * @param {PositionChangeDto} positionChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePosition(code: string, positionChangeDto: PositionChangeDto, options?: RawAxiosRequestConfig): AxiosPromise<PositionDto> {
            return localVarFp.updatePosition(code, positionChangeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * A tag out of use stays on the questions that carry it and in their history, but the lists that offer tags to add leave it out (activeOnly), and an import refuses it. For a tag that only duplicates another, merge instead: that moves its questions as well.
         * @summary Take a tag out of use, or back into it
         * @param {string} tagId 
         * @param {TagChangeDto} tagChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(tagId: string, tagChangeDto: TagChangeDto, options?: RawAxiosRequestConfig): AxiosPromise<TagDto> {
            return localVarFp.updateTag(tagId, tagChangeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DictionariesApi - interface
 * @export
 * @interface DictionariesApi
 */
export interface DictionariesApiInterface {
    /**
     * 
     * @summary Create a category
     * @param {CategoryRequestDto} categoryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    createCategory(categoryRequestDto: CategoryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDto>;

    /**
     * 
     * @summary Create a tag
     * @param {TagRequestDto} tagRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    createTag(tagRequestDto: TagRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TagDto>;

    /**
     * For one added by mistake. Only while no question is in it and no test draws from it; otherwise 409 with reason IN_USE and the count in detail — deactivate it instead.
     * @summary Delete a category nothing uses
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    deleteCategory(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * For one added by mistake. Only while no question carries it; otherwise 409 with reason IN_USE and the count in detail — merge it into another tag instead.
     * @summary Delete a tag no question carries
     * @param {string} tagId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    deleteTag(tagId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary List categories
     * @param {boolean} [activeOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    listCategories(activeOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryDto>>;

    /**
     * jAIn\'s dictionary of positions, copied once a night and changed in jAIn — except whether Ankieter uses a position, which is marked here and survives every copy. A name may stand for more than one position — Kierownik Sklepu has one number in JMD and another in JMS — so the company goes with every entry. Small enough to be listed whole.
     * @summary Positions, as copied from jAIn
     * @param {string} [q] A fragment of the name or of the number, letter case and Polish letters aside. Leave it out for every position.
     * @param {boolean} [activeOnly] true for the positions a question may still be given.
     * @param {boolean} [inAnkieterOnly] true for the positions marked as used in Ankieter — what every list to choose a position from offers. Combine with activeOnly to leave out what jAIn switched off.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    listPositions(q?: string, activeOnly?: boolean, inAnkieterOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PositionDictionaryDto>;

    /**
     * Not a dictionary, just suggestions while typing: the names questions cite their procedures by. The point is that the same procedure is spelled the same way twice, so a review after it changes finds every question — listQuestions takes the name as procedureName.
     * @summary Procedure names already used in the bank
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    listProcedureNames(q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * With \"q\" it serves suggestions while an author types. Suggestions are what actually prevents duplicates; merging only cleans up after them.
     * @summary List tags
     * @param {string} [q] 
     * @param {boolean} [activeOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    listTags(q?: string, activeOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<TagDto>>;

    /**
     * Moves every question from the source tag to the target and deactivates the source. For the \"bhp\" / \"BHP\" / \"b.h.p.\" that appear after a few months of everyone tagging as they go.
     * @summary Merge one tag into another
     * @param {string} tagId The tag being merged away
     * @param {MergeTagRequestDto} mergeTagRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    mergeTags(tagId: string, mergeTagRequestDto: MergeTagRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TagDto>;

    /**
     * The code prefix can only change while the category has no questions — it is already baked into the keys that were issued. A category in use is not deleted but deactivated: deleting it would strip the classification from its questions and break reports.
     * @summary Rename a category, reorder it or take it out of use
     * @param {string} categoryId 
     * @param {CategoryRequestDto} categoryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    updateCategory(categoryId: string, categoryRequestDto: CategoryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDto>;

    /**
     * The one thing about a position that is decided here rather than in jAIn. Only what the lists offer changes: a question or test that has the position keeps it either way.
     * @summary Mark whether Ankieter uses a position
     * @param {string} code The number of the function in MDR.
     * @param {PositionChangeDto} positionChangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    updatePosition(code: string, positionChangeDto: PositionChangeDto, options?: RawAxiosRequestConfig): AxiosPromise<PositionDto>;

    /**
     * A tag out of use stays on the questions that carry it and in their history, but the lists that offer tags to add leave it out (activeOnly), and an import refuses it. For a tag that only duplicates another, merge instead: that moves its questions as well.
     * @summary Take a tag out of use, or back into it
     * @param {string} tagId 
     * @param {TagChangeDto} tagChangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    updateTag(tagId: string, tagChangeDto: TagChangeDto, options?: RawAxiosRequestConfig): AxiosPromise<TagDto>;

}

/**
 * DictionariesApi - object-oriented interface
 * @export
 * @class DictionariesApi
 * @extends {BaseAPI}
 */
export class DictionariesApi extends BaseAPI implements DictionariesApiInterface {
    /**
     * 
     * @summary Create a category
     * @param {CategoryRequestDto} categoryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public createCategory(categoryRequestDto: CategoryRequestDto, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).createCategory(categoryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a tag
     * @param {TagRequestDto} tagRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public createTag(tagRequestDto: TagRequestDto, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).createTag(tagRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For one added by mistake. Only while no question is in it and no test draws from it; otherwise 409 with reason IN_USE and the count in detail — deactivate it instead.
     * @summary Delete a category nothing uses
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public deleteCategory(categoryId: string, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).deleteCategory(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For one added by mistake. Only while no question carries it; otherwise 409 with reason IN_USE and the count in detail — merge it into another tag instead.
     * @summary Delete a tag no question carries
     * @param {string} tagId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public deleteTag(tagId: string, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).deleteTag(tagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List categories
     * @param {boolean} [activeOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public listCategories(activeOnly?: boolean, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).listCategories(activeOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * jAIn\'s dictionary of positions, copied once a night and changed in jAIn — except whether Ankieter uses a position, which is marked here and survives every copy. A name may stand for more than one position — Kierownik Sklepu has one number in JMD and another in JMS — so the company goes with every entry. Small enough to be listed whole.
     * @summary Positions, as copied from jAIn
     * @param {string} [q] A fragment of the name or of the number, letter case and Polish letters aside. Leave it out for every position.
     * @param {boolean} [activeOnly] true for the positions a question may still be given.
     * @param {boolean} [inAnkieterOnly] true for the positions marked as used in Ankieter — what every list to choose a position from offers. Combine with activeOnly to leave out what jAIn switched off.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public listPositions(q?: string, activeOnly?: boolean, inAnkieterOnly?: boolean, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).listPositions(q, activeOnly, inAnkieterOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Not a dictionary, just suggestions while typing: the names questions cite their procedures by. The point is that the same procedure is spelled the same way twice, so a review after it changes finds every question — listQuestions takes the name as procedureName.
     * @summary Procedure names already used in the bank
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public listProcedureNames(q?: string, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).listProcedureNames(q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * With \"q\" it serves suggestions while an author types. Suggestions are what actually prevents duplicates; merging only cleans up after them.
     * @summary List tags
     * @param {string} [q] 
     * @param {boolean} [activeOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public listTags(q?: string, activeOnly?: boolean, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).listTags(q, activeOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Moves every question from the source tag to the target and deactivates the source. For the \"bhp\" / \"BHP\" / \"b.h.p.\" that appear after a few months of everyone tagging as they go.
     * @summary Merge one tag into another
     * @param {string} tagId The tag being merged away
     * @param {MergeTagRequestDto} mergeTagRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public mergeTags(tagId: string, mergeTagRequestDto: MergeTagRequestDto, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).mergeTags(tagId, mergeTagRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The code prefix can only change while the category has no questions — it is already baked into the keys that were issued. A category in use is not deleted but deactivated: deleting it would strip the classification from its questions and break reports.
     * @summary Rename a category, reorder it or take it out of use
     * @param {string} categoryId 
     * @param {CategoryRequestDto} categoryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public updateCategory(categoryId: string, categoryRequestDto: CategoryRequestDto, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).updateCategory(categoryId, categoryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The one thing about a position that is decided here rather than in jAIn. Only what the lists offer changes: a question or test that has the position keeps it either way.
     * @summary Mark whether Ankieter uses a position
     * @param {string} code The number of the function in MDR.
     * @param {PositionChangeDto} positionChangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public updatePosition(code: string, positionChangeDto: PositionChangeDto, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).updatePosition(code, positionChangeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A tag out of use stays on the questions that carry it and in their history, but the lists that offer tags to add leave it out (activeOnly), and an import refuses it. For a tag that only duplicates another, merge instead: that moves its questions as well.
     * @summary Take a tag out of use, or back into it
     * @param {string} tagId 
     * @param {TagChangeDto} tagChangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public updateTag(tagId: string, tagChangeDto: TagChangeDto, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).updateTag(tagId, tagChangeDto, options).then((request) => request(this.axios, this.basePath));
    }
}

